// extracted by mini-css-extract-plugin
export var equalColumn = "_fh-0";